import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import React, { useMemo } from "react";

type ReusableModalProps = {
  isOpen: boolean;
  setIsOpen: Function;
  modalTitle?: string | React.ReactElement;
  buttons?: React.ReactElement[];
  children?: React.ReactElement;
  maxWidth?: string;
  maxHeight?: string;
  width?: string;
  height?: string;
};

export default function ReusableModal({
  isOpen,
  setIsOpen,
  modalTitle = "",
  buttons = [],
  children,
  maxHeight,
  maxWidth,
  width,
  height,
}: ReusableModalProps) {
  const modalStyle = useMemo(
    () => ({
      position: "absolute" as "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      minWidth: "30%",
      maxWidth: maxWidth ?? "80%",
      maxHeight: maxHeight ?? "80%",
      width: width ?? "auto",
      bgcolor: "background.paper",
      border: "1px solid rgba(0,0,0,0.7)",
      boxShadow: 10,
      p: 1,
      borderRadius: 2,
      display: "flex",
      flexDirection: "column",
      height: height ?? "auto",
    }),
    [height, maxHeight, maxWidth, width]
  );
  return (
    <Modal
      // keepMounted
      open={isOpen}
      onClose={() => setIsOpen()}
      children={
        <Box sx={modalStyle}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            mb={1}
          >
            <Box>{modalTitle}</Box>
            <Box>
              <IconButton
                onClick={() => setIsOpen()}
                aria-label="close"
                color="secondary"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
          <Box
            overflow={"auto"}
            maxHeight={"100%"}
            minHeight={0}
            display={"flex"}
            flexDirection={"column"}
          >
            {children}
          </Box>
          {buttons.length > 0 && (
            <Box display={"flex"} justifyContent={"flex-end"} gap={1} pt={1}>
              {buttons.map((item, index) => (
                <Box key={index}>{item}</Box>
              ))}
            </Box>
          )}
        </Box>
      }
    />
  );
}
